module.exports = __webpack_public_path__ + "img/Welding_Ring_Set.cf567440.webp";